import React, { useEffect } from 'react';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { OverlayProvider } from '@uhg-abyss/web/ui/OverlayProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import Main from './Main/Main';
import APP_CONSTANT from './Main/constant';

const theme: any = createTheme('uhc', APP_CONSTANT?.themeOverride);
theme.themeVariantFonts();

export const Footer = () => {
    useEffect(() => {
        window.dispatchEvent(new CustomEvent('parcelLoad'));
    }, []);

    return (
        <ThemeProvider theme={theme} includeBaseCss={APP_CONSTANT?.includeBaseCss}>
            <OverlayProvider data-testid="overlay-provider">
                <Main data-testid="main-component" footerInfo={APP_CONSTANT?.footerInfo} />
            </OverlayProvider>
        </ThemeProvider>
    );
};
